// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import RouteBuilder from '@Services/RouteBuilder';
import { CardContentProps } from '../CardContentType';
import StreamCard from '@Organisms/LiveStreamData/StreamCard/StreamCard';
import { PropRender } from '@Organisms/LiveStreamData/PropRenderer/PropRenderer';
import { formatObservableTitle } from '@Helpers/observable';
import { ICONS } from '@Constants/iconsApp';
import { useLocalMessage } from '@Helpers/locale';

export const ObservableContent = ({ data: dataObservable, base }: CardContentProps): ReactElement => {
    const local = useLocalMessage();

    const {
        attachment = undefined,
        dataType,
        data = '',
        case: caseData,
        _id: observableId,
        tags,
        message,
    } = dataObservable || base.details;

    const { action, _id, details, context } = base;
    const title = formatObservableTitle({ attachment, data });

    const path = RouteBuilder.compute('cases.observable', { caseId: caseData?._id, observableId });

    const parent = caseData || context;

    const libTitle = {
        create: local('stream.card.observable.create'),
        update: local('stream.card.observable.update'),
        delete: local('stream.card.observable.delete'),
    };

    const displayTitle = action === 'delete' ? libTitle.delete : `${dataType}: ${title}`;

    const detailsCreated = {
        tags,
        description: message,
    };

    return (
        <StreamCard
            icon={<ICONS.ObservableIcon />}
            title={displayTitle}
            path={path}
            base={base}
            parent={parent}
            information="observable"
        >
            {action === 'create' &&
                Object.entries(detailsCreated).map(([key, value]) => (
                    <PropRender key={_id + key} prop={key} value={value} type="observable" />
                ))}

            {action === 'update' &&
                Object.entries(details).map(([key, value]) => (
                    <PropRender key={_id + key} prop={key} value={value} type="observable" />
                ))}
        </StreamCard>
    );
};
